import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ApiFactoryService} from '../../../shared/services/api-factory.service';
import {AbstractBffApi} from '../../../models/sharedinterface';
import {CurdUserprofilService} from '../../../shared/services/curd-userprofil.service';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {ShareddataService} from '../../../shared/services/shareddata.service';
import {MatTableDataSource} from '@angular/material/table';
import {MatSort} from '@angular/material/sort';
import {MatPaginator} from '@angular/material/paginator';
import {concatMap} from 'rxjs/operators';


@Component({
  selector: 'app-userprofilview',
  templateUrl: './userprofilview.component.html',
  styleUrls: ['./userprofilview.component.scss']
})
export class UserprofilviewComponent implements OnInit {


  confirmDialog: BsModalRef;
  dialogEntityid = '';
  entityroot = '';

  displayedColumns: any = [];
  keyColumns: any = []; // Columns with link
  datalistsource: MatTableDataSource<any>; // MatTableDataSource
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;


  private bffapi: AbstractBffApi;
  label = [];

  constructor(
    protected httpcrud: CurdUserprofilService, // Specific
    protected route: ActivatedRoute,
    protected router: Router,
    private apifactory: ApiFactoryService,
    protected modalservice: BsModalService,
    private shareddata: ShareddataService,
  ) {
    this.bffapi = this.apifactory.createBffApi();

    this.shareddata.editprofilviewinterface$.subscribe((data) => {
      this.label = data;
    });
  }

  getCreateLink() {
    const pathURL = window.location.pathname;
    return [pathURL + '/edit'];
  }


  ngOnInit() {
    this.initSpecificListConfig();
    this.initList();
  }

  initSpecificListConfig() {
    // Specific
    // this.displayedColumns = ['label', 'eventDate', 'validFrom', 'validTo', 'Client', 'Tool', 'delete'];
    // this.keyColumns = ['label'];
    this.entityroot = '/profil';

    const currentLNG = this.shareddata.getCurrentlanguage();
    this.httpcrud.getTranslationView(currentLNG.key)
      .subscribe((data) => {
        this.label = data.results;
      }); // subscribe
  }

  getCrud() {
    return this.httpcrud;
  }

  onDataSourceReady() {

  } // initListFilters

  initList() {
    const query = this.httpcrud.getEntities();
    query.subscribe((allresults) => {
      this.datalistsource = new MatTableDataSource(allresults.results);
      this.datalistsource.sort = this.sort;
      this.datalistsource.paginator = this.paginator;
      this.onDataSourceReady();
    });
  } // initList

  isKeyColumn(columnname: string) {
    return this.keyColumns.indexOf(columnname) !== -1;
  } // isKeyColumn

  closeConfirmRemoveDialog() {
    this.dialogEntityid = '';
    this.confirmDialog.hide();
  }

  confirmRemoveDialog(template: TemplateRef<any>, entityid: string = '') {
    this.dialogEntityid = entityid;
    this.confirmDialog = this.modalservice.show(template);
  }

  confirmEntityDeletion() {
    const query = this.httpcrud.removeEntity(this.dialogEntityid).pipe(
      concatMap(() => this.httpcrud.getEntities())
    );

    query.subscribe((allresults) => {

      this.datalistsource = new MatTableDataSource(allresults.results);
      this.datalistsource.sort = this.sort;
      this.datalistsource.paginator = this.paginator;

      this.closeConfirmRemoveDialog();
    });


  }

  getAdminentityurl() {
    return this.entityroot;
  } // getAdminentitylink

  getEditLink(entityid: string = '') {
    return [this.entityroot + '/' + entityid + '/edit'];
  } // getEditLink

  getDetailsLink(entityid: string = '') {
    return [this.entityroot + '/' + entityid];
  }

  getEditUrl(entityid: string = '') {
    return this.entityroot + '/' + entityid + '/edit';
  } // getEditUrl

  getEditSubLink(entityid: string = '') {
    return [window.location.pathname + '/' + entityid + '/edit'];
  } // getEditSubLink

  getUserListLink(entityid: string = '') {
    return [window.location.pathname + '/' + entityid + '/users'];
  } // getUserListLink

  getCreatSubLink() {
    return [window.location.pathname + '/create'];
  }





}

